import {
  FareEstimateErrorApiModel,
  FieldErrorApiModel,
} from '../api-models/FareEstimateValidatorErrorApiModel';
import {
  FareEstimateFieldErrors,
  FareEstimateError,
} from '../entities/FareEstimateValidatorError';

function toFieldErrors(
  fieldErrors: Array<FieldErrorApiModel>,
): FareEstimateFieldErrors {
  return fieldErrors.reduce(
    (accumulator: FareEstimateFieldErrors, current: FieldErrorApiModel) => {
      if (current.message === '') {
        return accumulator;
      }
      switch (current.field_name) {
        case 'from_address':
          return { ...accumulator, pickup: current.message };
        case 'to_address':
          return { ...accumulator, drop: current.message };
        case 'name':
          return { ...accumulator, name: current.message };
        case 'customer_mobile':
          return { ...accumulator, mobile: current.message };
        case 'frequency':
          return { ...accumulator, requirement: current.message };
        default:
          return accumulator;
      }
    },
    {},
  );
}

export function toFareEstimateError(
  error: FareEstimateErrorApiModel,
): FareEstimateError {
  return {
    fieldErrors: error.field_errors
      ? toFieldErrors(error.field_errors)
      : undefined,
    formError: error.form_error,
  };
}
